export function attachQueryParamsToUrl(url, params = {}) {
  const urlObject = new URL(url)
  for (const key in params) {
    urlObject.searchParams.set(key, params[key])
  }

  return urlObject.toString()
}
